import Link from "next/link";

import { Date as PrismicDate } from "prismic-reactjs";

import SectionShell from "components/Section-Shell";
import { getAllBlogPosts, BlogPost } from "lib/prismic/blog";

const Blog = ({ blogPost }: { blogPost: BlogPost }) => {
  const { publish_date, title, excerpt, cover_image } = blogPost.data;
  return (
    <div className="w-full ">
      <div className="h-full pt-4 pb-8 rounded-xl shadow-lg">
        <Link href={`/blog/${blogPost.uid}`} passHref>
          <a>
            {cover_image?.url && (
              <img
                className="mb-4 h-48 w-full object-center object-contain"
                src={cover_image?.url}
                alt={title[0].text}
              />
            )}
            <div className="px-6 text-gray-900">
              <small>
                {new Date(PrismicDate(publish_date)).toLocaleDateString()}
              </small>
              <h3 className="text-xl my-3 font-heading">{title[0].text}</h3>
              <p className="text-gray-700">{excerpt[0].text}</p>
            </div>
            {/* {tags && (
              <div className="px-6 flex flex-wrap flex-row-reverse">
                {tags.map(({ tag }) => (
                  <span
                    key={typeof tag === "string" ? tag : tag[0].text}
                    className="m-1 p-1 bg-blue-500 text-white text-sm font-semibold rounded shadow"
                  >
                    {typeof tag === "string" ? tag : tag[0].text}
                  </span>
                ))}
              </div>
            )} */}
          </a>
        </Link>
      </div>
    </div>
  );
};

const Index = ({ blogs }: { blogs: BlogPost[] }) => {
  return (
    <SectionShell
      heading="The Daisho.ml Blog"
      subtitle="Thoughts | Views | Updates"
      id="case-studies"
    >
      <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {blogs.map((post) => (
          <Blog key={post.uid} blogPost={post} />
        ))}
      </div>
    </SectionShell>
  );
};

export default Index;

export async function getStaticProps({ preview = false, previewData }) {
  const blogs = await getAllBlogPosts(previewData);
  return { props: { preview, blogs } };
}
